export default "__VITE_ASSET__82adae96__"